import { Box, CircularProgress, Typography } from '@material-ui/core';
import React from 'react';

const CircularProgressWithLabel = (props) => {
    const size = props.size || 46;

    return (
        <div
          className='d-flex flex-column'
          style={{ position: 'relative', width: size, height: size }}
        >
          <CircularProgress variant="determinate" {...props} size={size} />
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              lineHeight: '1',
              fontWeight: 500
            }}
          >
            
              {`${Math.round(props.value)}%`}
            
          </div>
        </div>
      );
};

export default CircularProgressWithLabel;
